import HeartLoader from '@monofront/design-system/components/HeartLoader';
import { useAuthentication } from '@context/businessContainer';
import { useEffect, useState } from 'react';
import { linkResolver } from '@utils/prismic';
import { useRouter } from 'next/router';
import {
  FilledContentRelationshipField,
  FilledLinkToWebField,
} from '@prismicio/client';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapRedirectionHandler } from './mapRedirectionHandler';
import { IRedirectionHandler } from './types';
import { Content } from '@prismicio/client';

const RedirectionHandler: React.FC<IRedirectionHandler> = ({ items }) => {
  const { isLoading, isMember, isAuthenticated } = useAuthentication();
  const [show, setShow] = useState<boolean>(true);
  const router = useRouter();

  const redirect = (item: Content.RedirectionHandlerSliceDefaultItem) => {
    switch (item.to.link_type) {
      case 'Web':
        router.push((item.to as FilledLinkToWebField).url);
        break;
      case 'Document':
        router.push(linkResolver(item.to as FilledContentRelationshipField));
        break;
    }
  };

  useEffect(() => {
    if (!isLoading) {
      items.forEach((item) => {
        if (
          (item.user_status === 'Member' && isMember) ||
          (item.user_status === 'Not Member' && !isMember) ||
          (item.user_status === 'Authenticated' && isAuthenticated) ||
          (item.user_status === 'Anonymous' && !isAuthenticated)
        ) {
          redirect(item);
        } else {
          setShow(false);
        }
      });
    }
  }, [isLoading]);

  return show ? (
    <>
      <section className="root">
        <div className="center">
          <HeartLoader size={100} />
        </div>
      </section>
      <style jsx>{`
        section {
          display: flex;
          justify-content: center;
          height: 90vh;
        }
      `}</style>
    </>
  ) : null;
};

export default withSlice(RedirectionHandler, mapRedirectionHandler);
